import SeoLandingPage from '../SeoLandingPage';

const config = {
  seoKey: 'acting',
  eyebrow: 'Acting Classes for Children in Milton Keynes',
  h1: 'Acting Classes',
  h1Accent: 'for Children in Milton Keynes',
  intro:
    'Engaging, ambitious acting classes for ages 4–18 in Milton Keynes. From improvisation and characterisation to scripted scene work, UPA gives young performers the tools — and the stage time — to grow into confident, expressive actors.',
  heroImage:
    'https://customer-assets.emergentagent.com/job_class-manager-84/artifacts/aanvvstv_228.JPG',
  bullets: [
    {
      title: 'Drama-first focus',
      body: 'Dedicated acting work every week — not a five-minute warm-up between dance numbers.',
    },
    {
      title: 'Stage opportunities',
      body: 'Termly showcases plus full productions where every child gets a role to sink their teeth into.',
    },
    {
      title: 'Screen-ready too',
      body: 'Scene study, sight reading and self-tape technique for kids exploring TV and film work.',
    },
    {
      title: 'Industry tutors',
      body: 'Trained by performers with credits in EastEnders, Hollyoaks, West End musicals and UK tours.',
    },
  ],
  whatYouLearn: [
    { title: 'Improvisation', body: 'Spontaneity, listening, "yes and" thinking — the foundation of every great actor.' },
    { title: 'Characterisation', body: 'Building a believable role: motivation, status, physicality and voice.' },
    { title: 'Script Work', body: 'Modern monologues, Shakespeare, contemporary plays and scene partner work.' },
    { title: 'Voice & Diction', body: 'Projection, articulation, accents and storytelling through voice.' },
    { title: 'Stagecraft', body: 'Blocking, presence, energy, and how to own a stage of any size.' },
    { title: 'Audition Skills', body: 'Self-tape framing, monologue selection, casting room confidence.' },
  ],
  ageGroups: [
    { ageRange: '4–6', label: 'Mini Stars' },
    { ageRange: '7–10', label: 'Juniors' },
    { ageRange: '11–14', label: 'Inters' },
    { ageRange: '15–18', label: 'Seniors' },
  ],
  relatedLinks: [
    { label: 'Musical Theatre Classes Milton Keynes', to: '/musical-theatre-classes-milton-keynes' },
    { label: 'Singing Classes Milton Keynes', to: '/singing-classes-milton-keynes' },
    { label: 'Dance Classes Milton Keynes', to: '/dance-classes-milton-keynes' },
    { label: 'Theatre School Milton Keynes', to: '/theatre-school-milton-keynes' },
    { label: 'View the Class Timetable', to: '/schedule' },
    { label: 'Book a Free Trial', to: '/free-trial' },
  ],
};

const ActingMK = () => <SeoLandingPage config={config} />;
export default ActingMK;
